import {lazy} from 'react';

export const MapGeoZonesLazy = lazy(() => import('./MapGeoZones'))